import { Environment } from '@app/shared/interfaces/environment';
import { FeatureState } from '@outlaw/core';

export const environment: Environment = {
  siteName: 'Dhar Mann',
  storeLinks: {
    apple: 'https://apps.apple.com/app/argo-short-films/id1508172165',
    google: 'https://play.google.com/store/apps/details?id=argomedia.app',
    roku: 'https://channelstore.roku.com/details/652e095f6e3134c32f65206625caa27c/argo',
  },
  hasTopMenu: true,
  phoneCodeLength: 6,
  production: true,
  passportServiceKey: 'KElHrqLOsUY0lohjxPajcQ',
  styleServiceKey: 'K0iGV4L9jNkaTvLEq5DVtw',
  profileUrl: 'https://passport.maji.la/auto_signin?token=',
  passportUrl: 'https://passport.maji.la/auth/login',
  passportExternalUrl: 'https://passport-api.maji.la',
  firebase: {
    apiKey: 'AIzaSyAzdyBOrHFHvACg_zJkYcHqcx3_sIXnRXQ',
    authDomain: 'argo-55e26.firebaseapp.com',
    databaseURL: 'https://argo-55e26.firebaseio.com',
    projectId: 'argo-55e26',
    storageBucket: 'argo-55e26.appspot.com',
    messagingSenderId: '754872181769',
    appId: '1:754872181769:web:354afffb2e1a47269cc4d8',
    // measurementId: 'G-9TCRSDZ5DJ', // old firebase measurement
    measurementId: 'G-MGH658F78M',
  },
  creatorUrl: 'https://community-admin.maji.la',
  websiteUrl: 'https://dhar-mann.maji.la',
  nftSiteUrl: 'https://nft.dhar-mann.maji.la',
  shortsSiteUrl: 'https://shorts.dhar-mann.maji.la',
  adsense: 'ca-pub-6497350777251423',
  braze: {
    apiKey: 'c5d45531-0d40-478b-8485-a1064ff2ca51', // prod
    baseUrl: 'sdk.iad-05.braze.com',
  },
  sentry: {
    dsn: 'https://7b4c06b297cc412cb0ea40ed3489153e@o452115.ingest.sentry.io/4504839801798656',
    origins: ['https://web.watchargo.com/'],
    rate: 0.2,
  },
  subscriptionsJson: 'assets/temp/subscriptions-prod.json',
  argoApiUrl: 'https://web.watchargo.com/api',
  communityApiUrl: 'https://community-api.maji.la/api',
  ownerId: '9e912929-91cf-46d9-8086-7947589cc172',
  groupId: '19',
  paymentServiceUrl: 'https://payments-api.maji.la',
  gptApiUrl: 'https://orchestrator.ot4.dev/api',
  useMockData: false,
  mockThreadCount: 5,
  featureFlags: {
    showWidgets: FeatureState.enabled,
  },
};
